import SbBoqIcon from "../img/SB-BOQ.png";
import SbProductIcon from "../img/SB-Product.png";
import SbResourceIcon from "../img/SB-Resource.png";

export const pageListAdmin = [
  {
    title: "boq",
    pathName: "/boq/lbd",
    icon: SbBoqIcon,
    status: true,
    manuUser: 1,
  },
  {
    title: "product",
    pathName: "/product",
    icon: SbProductIcon,
    status: true,
    manuUser: 1,
  },
  {
    title: "resource",
    pathName: "/resource",
    icon: SbResourceIcon,
    status: true,
    manuUser: 1,
  },
];
